import { fetchData } from "@request";

export type Balance = {
  frozen_balance: number;
  pay_in: number;
  pay_out: number;
  trust_balance: number;
};

export type SaveFrozenBalance = {
  frozen_balance: number;
  save_balance: number;
};

export type TransferMoneyForm = {
  amount: number;
  ern_balance_id?: string;
  operation: "pay_in" | "pay_out";
  trust_balance_id?: string;
  user_id: string;
};

export type UsdtPrice = { currentPrice: number };

export const getBalances = async (userId: string) => {
  try {
    const response = await fetchData<Balance>({
      url: `api/v1/users/finance-balances/${userId}`,
    });

    return response;
  } catch (error) {
    console.error("Balances failed:", error);
    throw error;
  }
};

export const getSaveFrozenBalances = async (userId: string) => {
  try {
    const response = await fetchData<SaveFrozenBalance>({
      url: `api/v1/users/save-frozen-balance/${userId}`,
    });

    return response;
  } catch (error) {
    console.error("Save and frozen balances failed:", error);
    throw error;
  }
};

export type AssignWalletResponse = { address: string; created_at_unix: number };

export const getAssignWallet = async (userId: string) => {
  try {
    const response = await fetchData<AssignWalletResponse>({
      method: "POST",
      url: `api/v1/users/assign-wallet/${userId}`,
    });

    return response;
  } catch (error) {
    console.error("Get assign wallet failed:", error);
    throw error;
  }
};

export const transferMoney = async (data: TransferMoneyForm) => {
  try {
    const response = await fetchData<string>({
      method: "POST",
      url: `api/v1/users/transfer-money`,
      data,
    });

    return response;
  } catch (error) {
    console.error("Get assign wallet failed:", error);
    throw error;
  }
};

export const getUsdtPrice = async () => {
  try {
    const response = await fetchData<UsdtPrice>({
      url: `api/v1/transactions/price/usd`,
    });

    return response;
  } catch (error) {
    console.error("Usdt price failed:", error);
    throw error;
  }
};
